import React, { useContext } from 'react'
import { AudienceSelection, SavedAudience } from '@marketing-milk/interfaces'
import { SurfacePalette } from '../../../tokens'
import { useSectionNumber } from '../../PacketSectionsContext'
import { PresentPage } from '../PresentPage'
import { AudienceContent } from '../../sections/AudienceContent'
import { useAudienceDetailModal } from '../../sections/useAudienceDetailModal'
import { PresentNavLockContext } from '../PresentNavLock'

interface Props {
  palette: SurfacePalette
  packetID: number
  audiences: SavedAudience[]
  audienceSelection: AudienceSelection | null
}

/**
 * Present-mode (dark) Audience slide. Read-only: no selection editing here (that
 * stays in Edit). The full-targeting deep-dive can still be opened in-meeting;
 * while it's open we lock deck Arrow/Esc navigation so it doesn't fire underneath
 * the dialog.
 */
export const PresentAudienceSection = ({
  palette,
  packetID,
  audiences,
  audienceSelection,
}: Props) => {
  const number = useSectionNumber('audience-framework')
  const setNavLocked = useContext(PresentNavLockContext)
  const { onOpenDetail, modals } = useAudienceDetailModal(setNavLocked)

  return (
    <PresentPage
      palette={palette}
      number={number}
      title="Audience framework"
      commentAnchor={{
        type: 'section',
        id: `${packetID}:audience-framework`,
        label: 'Audience framework',
      }}
    >
      <AudienceContent
        palette={palette}
        audiences={audiences}
        primaryAudienceID={audienceSelection?.primaryAudienceID ?? null}
        onOpenDetail={onOpenDetail}
      />
      {modals}
    </PresentPage>
  )
}
